import { render, staticRenderFns } from "./tool_adapt_mould.vue?vue&type=template&id=9994013a&scoped=true&"
import script from "./tool_adapt_mould.vue?vue&type=script&lang=js&"
export * from "./tool_adapt_mould.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9994013a",
  null
  
)

export default component.exports